import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import { TDownloadEVerifyNotice } from "./downloadEVerifyNoticeSchema";

export const downloadEVerifyNotice = (axios: IAxiosInstance) => {
  return async (data: TDownloadEVerifyNotice) => {
    const response = await axios.noRetry.get<IApiResponse<string>>(
      "/api/downloadEVerifyNotice",
      { params: data }
    );
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
